import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Book from "./pages/Book";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import AuthCallback from "./pages/AuthCallback";
import Admin from "./pages/Admin";
import Cancel from "./pages/Cancel";
import Reschedule from "./pages/Reschedule";
import { AuthProvider } from "./context/AuthContext";
import axios from "axios";

// Send cookies with every axios call by default
axios.defaults.withCredentials = true;

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth return synchronously during render (not in useEffect)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/book" element={<Book />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/cancel/:id" element={<Cancel />} />
        <Route path="/reschedule/:id" element={<Reschedule />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#FDFBF7",
                border: "1px solid #EAE0D5",
                color: "#3A2E2B",
                borderRadius: "9999px",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
